<template>
    <div >
        <div class="one-half small-half">
            <div data-height="95" class=" round-small shadow-huge">
                <div class="caption-image">
                    <img v-bind:src="'images/mpower/'+image" class="responsive-image">
                    <!-- <img src="images/pictures/18m.jpg" class="responsive-image"> -->
                </div>
            </div>   
        </div>
        <div class="one-half large-half last-column text-left ">
            <h2 class="color-theme uppercase">{{title}}</h2>
            <span class="under-heading font-12 color-highlight">{{description1}}</span>
            <p class="font-10 color-white">
               {{description2}}
            </p>
        </div>
    </div>  
</template>

<script>
export default {
  name: 'ExploreTitle',
  props: {
    icon: String,
    title: String,
    description1: String,
    description2: String,
    color: String,
    image: String,
    positionSlide2: String,
    link: String,
  },
  computed: {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.color-highlight{
    color:#6c6c6c;
}
</style>
